export const isProduction = () => window.location.origin === 'https://bbofa.org' || window.location.origin === 'https://www.bbofa.org';
